import React from 'react';
import {
  Body,
  Headline,
  designSystemToken,
} from '@lightricks/react-design-system';
import {Paper, Box, styled} from '@mui/material';
import {GigBase} from '@/types/gigs';
import {media} from '@/styles/mediaQueries';

export interface GigCardBaseProps {
  gig: GigBase;
  children?: React.ReactNode;
  className?: string;
}

// Styled components for the card
export const StyledCardFrame = styled(Paper)(() => ({
  'position': 'relative',
  'display': 'flex',
  'flexDirection': 'column',
  'width': '351px',
  'height': '430px',
  'boxShadow': '0 1px 3px rgba(0, 0, 0, 0.11)',
  'background': designSystemToken('semantic.bg.primary'),
  'borderRadius': '5px',
  'transition': 'transform 0.2s ease, box-shadow 0.2s ease',
  'cursor': 'pointer',
  '&:hover': {
    'transform': 'translateY(-2px)',
    'boxShadow': '0 4px 8px rgba(0, 0, 0, 0.1)',
    '& .gig-card-title': {
      textDecoration: 'underline',
    },
  },
  [media.mobile]: {
    width: '100%',
  },
  [`&:hover .card-title`]: {
    textDecoration: 'underline',
  },
}));

const shouldNotForwardProps = ['imageUrl'];

export const StyledCardImage = styled(Box, {
  shouldForwardProp: (prop: string) => !shouldNotForwardProps.includes(prop),
})<{imageUrl?: string}>(({imageUrl}) => ({
  height: '180px',
  position: 'relative',
  backgroundImage: imageUrl
    ? `url(${imageUrl})`
    : 'linear-gradient(45deg, #ebebeb 25%, transparent 25%), linear-gradient(-45deg, #ebebeb 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #ebebeb 75%), linear-gradient(-45deg, transparent 75%, #ebebeb 75%)',
  backgroundSize: imageUrl ? 'cover' : '20px 20px',
  backgroundPosition: imageUrl
    ? 'center center'
    : '0 0, 0 10px, 10px -10px, -10px 0px',
  display: 'flex',
  justifyContent: 'flex-end',
  borderRadius: '5px 5px 0 0',
  padding: '14px',
}));

export const StyledCardContent = styled(Box)(() => ({
  minHeight: '220px',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  overflowY: 'auto',
}));

export const StyledCardHeader = styled(Box)(() => ({
  padding: '18px 20px',
  flex: '0 0 auto',
  display: 'flex',
  flexDirection: 'column',
}));

export const StyledHeaderTop = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'baseline',
}));

export const StyledBrand = styled(Body)(() => ({
  color: designSystemToken('semantic.fg.secondary'),
  display: 'block',
  fontSize: '16px',
  lineHeight: '100%',
  marginBottom: '14px',
  position: 'relative',
}));

export const StyledTitle = styled(Headline)(() => ({
  fontSize: '20px',
  lineHeight: 1.2,
  fontWeight: 'bold',
  margin: 0,
  minHeight: '48px',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));
